export default __webpack_public_path__ + "static/media/MVIMG_20190606_103743.80519c2b.png";